import { Search, ChevronRight, Info } from "lucide-react";

const GoogleShoppingPreview = ({ 
  products = [], 
  searchTerm = "Keywords del anuncio" 
}) => {
  const isError = products && typeof products === "object" && "error" in products;

  return (
    <div className="flex flex-col items-center py-8">
      {/* Barra de búsqueda simulada */}
      <div className="w-full max-w-2xl mb-6">
        <div className="flex items-center border border-gray-300 rounded-full bg-white shadow-sm px-4 py-2">
          <Search className="w-5 h-5 text-gray-500" />
          <input
            type="text"
            value={searchTerm}
            readOnly
            className="flex-1 ml-2 outline-none text-sm text-gray-900 bg-transparent placeholder-gray-500"
            placeholder="Buscar en Google"
          />
        </div>
      </div>

      {/* Contenedor de resultados */}
      <div className="w-full max-w-3xl bg-white rounded-xl shadow border border-gray-200">
        <div className="px-4 pt-4 flex justify-between items-center">
          <h2 
            className="text-[#1a0dab] text-base font-medium leading-snug"
            style={{ lineHeight: "1.3" }}
          >
            Resultados de Google Shopping
          </h2>
          <div className="flex items-center text-gray-600 text-[12px]">
            <span>Enlaces Patrocinados</span>
            <Info className="w-4 h-4 ml-1 text-gray-400" strokeWidth={2} />
          </div>
        </div>

        <div className="relative px-4 py-6">
          {/* Error visual */}
          {isError ? (
            <div className="text-center text-sm py-8">
              {products.error || "Error al cargar productos de Google Merchant."}
            </div>
          ) : products.length === 0 ? (
            <div className="text-gray-500 text-center w-full py-12">
              No hay productos para previsualizar.
            </div>
          ) : (
            <div className="flex space-x-2 overflow-x-auto">
              {products.map((product) => {
                let hostname = "";
                try {
                  hostname = new URL(product.link).hostname.replace("www.", "");
                } catch {
                  hostname = "";
                }

                return (
                  <div
                    key={product.id}
                    className="flex-shrink-0 w-40 border border-gray-200 rounded-lg bg-white shadow-sm"
                  >
                    <a
                      href={product.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block"
                    >
                      <div className="w-full h-32 bg-gray-100 overflow-hidden rounded-t-lg">
                        <img
                          src={product?.imageLink}
                          alt={product?.title}
                          className="w-full h-full object-cover"
                        />
                      </div>
                      <div className="px-2 py-2">
                        <p className="text-[13px] text-[#0B57D0] font-medium line-clamp-1 mb-1">
                          {product?.title}
                        </p>
                        <p className="text-[14px] font-semibold">
                          {product?.price?.value || ""}{" "}
                          <span className="text-[12px] font-medium">
                            {product?.price?.currency || ""}
                          </span>
                        </p>
                        {hostname && (
                          <p className="text-gray-600 text-[11px] truncate mt-1">
                            {hostname}
                          </p>
                        )}
                      </div>
                    </a>
                  </div>
                );
              })}
            </div>
          )}

          {/* Flecha lateral */}
          {!isError && products.length > 0 && (
            <div className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-white border border-gray-200 rounded-full w-8 h-8 flex items-center justify-center shadow-md">
              <ChevronRight className="w-5 h-5 text-gray-600" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GoogleShoppingPreview;
